import React, { createContext, useContext, useReducer } from 'react';
import logger from 'use-reducer-logger';

const SearchStateFiltersContext = createContext( null );

const SearchStateFilterDispatchContext = createContext( null );

export function SearchStateFiltersProvider( { children } ) {
	const [ searchFilters, dispatch ] = useReducer(
		process.env.NODE_ENV === 'development' ? logger( searchStateFiltersReducer ) : searchStateFiltersReducer,
		initialValues
	);

	return (
		<SearchStateFiltersContext.Provider value={searchFilters}>
			<SearchStateFilterDispatchContext.Provider value={dispatch}>
				{children}
			</SearchStateFilterDispatchContext.Provider>
		</SearchStateFiltersContext.Provider>
	);
}

export function useSearchStateFilters() {
	return useContext( SearchStateFiltersContext );
}

export function useSearchStateFiltersDispatch() {
	return useContext( SearchStateFilterDispatchContext );
}

function searchStateFiltersReducer( existingState, action ) {
	switch ( action.type ) {
		case 'changed': {
			const newState = {
				...existingState,
				sqFtRange: action.sqFtRange ? [ action.sqFtRange[ 0 ], action.sqFtRange[ 1 ] ] : existingState.sqFtRange,
				priceRange: action.priceRange ? [ action.priceRange[ 0 ], action.priceRange[ 1 ] ] : existingState.priceRange,
				bedrooms: action.bedrooms ? { ...action.bedrooms } : existingState.bedrooms,
				bathrooms: action.bathrooms ? { ...action.bathrooms } : existingState.bathrooms,
				garages: action.garages ? { ...action.garages } : existingState.garages,
			};
			window.algoliaSearchState.filters = newState;
			return newState;
		}
		case 'reset': {
			window.algoliaSearchState.filters = initialValues;
			return initialValues;
		}
		default: {
			throw Error( 'Unknown action: ' + action.type );
		}
	}
}

const initialValues = {
	sqFtRange: [ null, null ],
	priceRange: [ null, null ],
	bedrooms: {
		min: null,
		max: null,
	},
	bathrooms: {
		min: null,
		max: null,
	},
	garages: {
		min: null,
		max: null,
	},
};

if ( ! window.algoliaSearchState ) {
	window.algoliaSearchState = {};
}
window.algoliaSearchState.filters = initialValues;

